export const environment = {
  production: false,
  apiUrl: 'https://lpgbidext-api-dev.tengizchevroil.com/api',
  oktaIssuer: 'https://cvxportal-nonprod.oktapreview.com',
  oktaClientId: '0oa1299ataypran841d8',
};
